import React from 'react';

import {
	ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE,
	LazyApplicationNavigatorPage,
} from '@confluence/site-settings';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const AdminApplicationNavigatorRoute = () => <LazyApplicationNavigatorPage />;

AdminApplicationNavigatorRoute.NAVIGATION_PARAMS = () => ({
	Screen: {
		screenEvent: { name: ADMIN_APPLICATION_NAVIGATOR_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
